import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutTemplate, WorkoutTemplateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateWorkoutTemplate(): UseMutationResult<
  AxiosResponse<WorkoutTemplate>,
  AxiosError<ErrorMessage>,
  WorkoutTemplateWrite
> {
  const queryClient = useQueryClient();

  const createWorkoutTemplate = (
    workoutTemplate: WorkoutTemplateWrite,
  ): Promise<AxiosResponse<WorkoutTemplate>> => {
    return client.post('workout-templates/', workoutTemplate);
  };

  return useMutation(createWorkoutTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutTemplates');
    },
  });
}
